
































































































































































































































































































































































































































































































































































































































































































































































































































































import {Component, Prop, Provide, Vue} from 'vue-property-decorator';
import SelectNodeField from '@c/controls/selectControls/SelectNodeField.vue';
import {
  PModuleTableHeader,
  DtcpAccelerometerModule,
  PModuleMAC,
} from '@/views/system/modules/interfaces';
import DtcpAccelerometerModuleMeasurementEditDialog from '@v/system/modules/forms/dtcp/DtcpAccelerometerModuleMeasurementEditDialog.vue';
import DtcpAccelerometerModuleFreqAndBandEditDialog from '@v/system/modules/forms/dtcp/DtcpAccelerometerModuleFreqAndBandEditDialog.vue';
import Table from '@c/tables/Table.vue';
import TableCheckBox from '@c/tables/TableCheckBox.vue';
import {PModuleMeasurementStore} from '@/views/system/modules/forms/pModuleMeasurementStore';
import {connectionGetActiveDevices} from '@/api/configApi';
import dtcpServerStoreModule from '@/store/modules/entities/pmodules/dtcp/dtcpServerStoreModule';
import pmoduleModule from '@/store/modules/entities/pmodules/pmoduleModule';
import {PModuleType} from '@/enums/configs';
import IconButton from '@c/controls/IconButton.vue';
import CancelChangesDialog from '@c/CancelChangesDialog.vue';
import router from '@/router';
import measurementsStoreModule from '@/store/modules/entities/measurementsModule';
import {updateMeasurements} from '../../moduleUtils';
import enumsModule from '@/store/modules/enumsModule';
import {httpClient} from '@api/baseApi';
import PModuleButtons from './../../../nodes/PModuleButtons.vue';
import nodeModule from '@/store/modules/entities/nodeModule';
import {replaceAt} from '@u/commonUtils';

@Component({
  components: {
    Table,
    TableCheckBox,
    SelectNodeField,
    DtcpAccelerometerModuleMeasurementEditDialog,
    DtcpAccelerometerModuleFreqAndBandEditDialog,
    IconButton,
    CancelChangesDialog,
    PModuleButtons,
  },
})
export default class DtcpAccelerometerModuleForm extends Vue {
  loading = false;
  saving = false;

  valid = true;

  notSendDefaultSpectrum = false;
  notSendTahoSpectrum = false;
  notSendRmsSpectrum = false;
  notSendEnergySpectrum = false;

  // список mac адресов для выбора
  macs: PModuleMAC[] = [];

  measurementDialog = DtcpAccelerometerModuleMeasurementEditDialog;

  @Provide()
  @Prop({required: true})
  pmodule!: DtcpAccelerometerModule;

  @Prop({required: false})
  mac?: string;

  @Prop({required: false})
  fromHardware?: boolean;

  showMac = true;
  showStatChannel = false;
  showAmpSpectrChannel = false;
  showPowerSpectrChannel = false;
  showEnvelopeSpectrChannel = false;
  showOctaveSpectrChannel = false;
  showRawSignalChannel = false;
  showVelocityStatChannel = false;
  showAccelStartFreq = false;
  showAccelEndFreq = false;
  showVelocityStartFreq = false;
  showVelocityEndFreq = false;
  showDisplacementStatChannel = false;
  showDisplacementStartFreq = false;
  showDisplacementEndFreq = false;
  showEnvelope3doctave = false;
  showEnvelope1doctave = false;
  showSyncChannel = false;
  showMeasTimeS = false;
  showPowerFftTypes = false;
  showDefaultSpectrumCount = false;

  tahoCrmValues: any = [];
  showTahoSpectrumCount = false;
  showTahoThreshold = false;

  energyModuleValues: any = [];
  showEnergySpectrumCount = false;
  showEnergyThreshold = false;

  showRmsXThreshold = false;
  showRmsYThreshold = false;
  showRmsZThreshold = false;
  showRmsSpectrumCount = false;

  dtcpAccelerometerModules: any = {};
  envelopeOneDoctaveBitLength = 0;
  envelopeThreeDoctaveBitLength = 0;

  am: any = [];

  get parentPmOptions() {
    return pmoduleModule.all.filter(
      m =>
        m.guid !== this.pmodule.guid &&
        m.guid &&
        (m.type === PModuleType.DtcpServerModule || m.type === PModuleType.DtcpEmulatorModule),
    );
  }

  get measurementsStore() {
    return new PModuleMeasurementStore(this.pmodule);
  }

  envelopeDoctaveItems(name: 'envelope_3doctave' | 'envelope_1doctave') {
    const base2 = this.pmodule[name].toString(2);
    const base2Length = base2.length - 1;
    let data: any[] = [];
    const module = this.dtcpAccelerometerModules.find(
      (item: any) => item.id === this.pmodule.sensor_type,
    );
    if (module) {
      data = module[name];
    }

    data = data.map(item => {
      return {
        ...item,
        isActive: base2[base2Length - item.bit] === '1',
        width: item.max - item.min,
      };
    });

    return {
      fetchAll: () => {
        return [...data];
      },
      all: [...data],
    };
  }

  get envelopeThreeDoctaveItems() {
    return this.envelopeDoctaveItems('envelope_3doctave');
  }

  get envelopeOneDoctaveItems() {
    return this.envelopeDoctaveItems('envelope_1doctave');
  }

  measurementsHeaders: PModuleTableHeader[] = [
    {
      text: 'Измерение',
      value: 'measurementDescription',
      sortable: false,
    },
    {
      text: 'В. гр. предупреждения',
      value: 'topWarningBoundary',
      sortable: false,
    },
    {
      text: 'В. гр. опасного значения',
      value: 'topDangerBoundary',
      sortable: false,
    },
    {
      text: 'В. гр. ошибки',
      value: 'topErrorBoundary',
      sortable: false,
    },
  ];

  envelopeDoctaveHeaders: PModuleTableHeader[] = [
    {
      text: 'Код',
      value: 'name',
      sortable: false,
    },
    {
      text: 'Нижняя граничная частота',
      value: 'min',
      sortable: false,
    },
    {
      text: 'Центральная частота',
      value: 'central',
      sortable: false,
    },
    {
      text: 'Верхняя граничная частота',
      value: 'max',
      sortable: false,
    },
    {
      text: 'Ширина полосы',
      value: 'width',
      sortable: false,
    },
  ];

  nonEmptyTextRule = (v: any) => !!v || (v && v.length === 0) || 'Поле обязательно для заполнения';

  RegExPattern = /^([0-9A-Fa-f]{12})$/;
  nonMACAddressRule = (v: any) => this.RegExPattern.test(v) || 'Поле должно быть МАС адресом';

  nonEmptyNumberRule = (v: any) => v != null || 'Поле обязательно для заполнения';

  nonNegativeNumberRule = (v: any) => v >= -1 || 'Поле должно быть неотрицательным числом или -1';

  tahoChannelRule = (v: any) =>
    v == 0 || v == 72 || v == 74 || 'Поле должно быть каналом тахометра (72, 74) или нулем';

  integerNumberRule = (v: any) => Number.isInteger(Number(v)) || 'Поле должно быть целым числом';

  socket!: WebSocket | null;

  async onSave() {
    this.pmodule.measurements = this.pmodule.measurements.filter((x: any) => x.isActive === true);

    this.valid = await (this.$refs.form as any).validate();

    if (!this.valid) {
      const error = document.querySelector('div.error--text');
      error && this.$vuetify.goTo(error as HTMLElement);
      return;
    }

    this.$emit('save');
  }

  //переменная, сигнализирующая о внесенных и несохраненных изменениях на форме
  changed = false;

  nodeName: any = null;

  getEnvelopeDoctave(items: any[], bitLength: number) {
    let mask = Array(bitLength)
      .fill(0)
      .join('');
    items
      .filter(item => item.isActive)
      .forEach(item => {
        mask = replaceAt(mask, item.bit, '1');
      });
    return parseInt(
      mask
        .split('')
        .reverse()
        .join(''),
      2,
    );
  }

  // Действия при изменении поля
  async onChange() {
    this.changed = true;
  }

  async onChangeEnvelopeThreeDoctaveItems() {
    this.changed = true;
    this.pmodule.envelope_3doctave = this.getEnvelopeDoctave(
      this.envelopeThreeDoctaveItems.all,
      this.envelopeThreeDoctaveBitLength,
    );
  }

  async onChangeEnvelopeOneDoctaveItems() {
    this.changed = true;
    this.pmodule.envelope_1doctave = this.getEnvelopeDoctave(
      this.envelopeOneDoctaveItems.all,
      this.envelopeOneDoctaveBitLength,
    );
  }

  async onChangeSensorType() {
    await this.onChangeEnvelopeThreeDoctaveItems();
    await this.onChangeEnvelopeOneDoctaveItems();
  }

  amFieldClick() {
    router.push(`/hardware/${this.am.id}`);
  }

  nodeFieldClick(index: number) {
    router.push(`/nodes/${this.pmodule.nodes ? this.pmodule.nodes[index].node_id : 0}`);
  }

  updateDefaultSpectrumFrequencyValue() {
    if (this.notSendDefaultSpectrum) this.pmodule.default_spectrum_count = -1;
    else this.pmodule.default_spectrum_count = 1;
  }

  updateTahoSpectrumFrequencyValue() {
    if (this.notSendTahoSpectrum) this.pmodule.taho_spectrum_count = -1;
    else this.pmodule.taho_spectrum_count = 1;
  }

  updateEnergySpectrumFrequencyValue() {
    if (this.notSendEnergySpectrum) this.pmodule.energy_spectrum_count = -1;
    else this.pmodule.energy_spectrum_count = 1;
  }

  updateRmsSpectrumFrequencyValue() {
    if (this.notSendRmsSpectrum) this.pmodule.rms_spectrum_count = -1;
    else this.pmodule.rms_spectrum_count = 1;
  }

  async loadAM() {
    if (!this.pmodule.guid) {
      // выходим если это новый ПМ
      return;
    }

    const {data} = await httpClient.get(`modules/`, {
      params: {
        guids: JSON.stringify([this.pmodule.guid]),
      },
    });
    const amId = data[0].hw_pm;
    if (amId != null) {
      const {data} = await httpClient.get<[]>(`hardware/${amId}`);
      this.am = data;
    }
  }

  async loadMeasurements() {
    // Подгружаем список измерений, ещё не использованных в таблице
    await measurementsStoreModule.fetchAll();
    if (this.pmodule.measurements) {
      const newEntities = measurementsStoreModule.entities.filter(
        (x: any) =>
          x.moduleType === this.pmodule.type &&
          !this.pmodule.measurements.some((y: any) => y.measurementId == x.id),
      );
      // если такие измерения найдены, добавляем их в таблицу измерений модуля
      if (newEntities.length > 0) {
        updateMeasurements(this.pmodule.measurements, newEntities);
      }
    }
  }

  async setValues(module: any) {
    const moduleParametersResponse: {data: any} = await httpClient.get(`${module.url}/`);
    const values = moduleParametersResponse.data;
    return values.map((x: any) => ({
      guid: x.guid,
      name: x.name,
    }));
  }

  async created() {
    const {data} = await httpClient.get(`/dtcp-accelerometer-modules/sensor-types/`);
    this.dtcpAccelerometerModules = data;
    data.forEach((item: any) => {
      item.envelope_3doctave.forEach((doctave: any) => {
        if (doctave.bit > this.envelopeThreeDoctaveBitLength) {
          this.envelopeThreeDoctaveBitLength = doctave.bit + 1;
        }
      });

      item.envelope_1doctave.forEach((doctave: any) => {
        if (doctave.bit > this.envelopeOneDoctaveBitLength) {
          this.envelopeOneDoctaveBitLength = doctave.bit + 1;
        }
      });
    });

    if (this.pmodule.nodes && this.pmodule.nodes.length) {
      const totalNodeNames: {title: string; value: number}[] = [];
      const nodesIds: number[] = this.pmodule.nodes.map((item, index) => index);

      const getNameNode = async (idx: number) => {
        if (this.pmodule.nodes) {
          const {data} = await nodeModule.edit(this.pmodule.nodes[idx].node_id);
          return {title: data.name, value: data.id ?? 0};
        }
      };

      for (const item of nodesIds) {
        const result = await getNameNode(item);
        if (result) {
          totalNodeNames.push(result);
        }
      }
      this.nodeName = totalNodeNames;
    }
    await this.loadAM(); // подтягиваем АМ программного модуля, если он привязан
    //для тех измерений, которые уже сохранены, проставляем isActive = true и isNew = false
    this.pmodule.measurements.forEach((elem: any) => {
      if (!elem.isNew) {
        elem.isActive = true;
        elem.isNew = false;
      }
    });

    if (this.fromHardware && this.pmodule && this.mac) {
      this.pmodule.device = this.mac;
    }

    this.notSendDefaultSpectrum = this.pmodule.default_spectrum_count < 0;
    this.notSendTahoSpectrum = this.pmodule.taho_spectrum_count < 0;
    this.notSendEnergySpectrum = this.pmodule.energy_spectrum_count < 0;
    this.notSendRmsSpectrum = this.pmodule.rms_spectrum_count < 0;

    if (this.fromHardware) this.showMac = false;

    await this.loadMeasurements();
    // получаем все модули и находим dtcp-сервер
    await pmoduleModule.fetchAll();
    const dtcpServers = pmoduleModule.all.filter(x => x.type === PModuleType.DtcpServerModule);
    if (dtcpServers.length) {
      // если есть dtcp-сервера, берем один из них
      const dtcpServer = dtcpServers[0];

      if (dtcpServer.guid) {
        //подключаемся к веб сокету
        this.socket = connectionGetActiveDevices(dtcpServer.guid);
        this.socket.onopen = () => {
          //отправляем action
          if (dtcpServer.id) {
            dtcpServerStoreModule.processGetActiveDevicesAction({id: dtcpServer.id});
          }
        };
        this.socket.onmessage = (e: any) => this.subscribeConectionWS(e);
      }
    }

    // поднгрузка тахометров
    const tahoModule = enumsModule.moduleTypes.find(v => v.value === PModuleType.DtcpTahoModule);
    const energyModule = enumsModule.moduleTypes.find(
      v => v.value === PModuleType.DtcpEnergyModule,
    );
    const crmModule = enumsModule.moduleTypes.find(v => v.value === PModuleType.CrmModule);
    if (tahoModule) this.tahoCrmValues = await this.setValues(tahoModule);
    if (crmModule) this.tahoCrmValues = this.tahoCrmValues.concat(await this.setValues(crmModule));
    if (energyModule) this.energyModuleValues = await this.setValues(energyModule);
  }

  subscribeConectionWS(e: {data: string}) {
    const strParse = JSON.parse(e.data);
    const macs = strParse.data.devices.map((x: any) => ({
      device: x.mac,
      description: `${x.mac} - ${x.type} (${x.fw_ver})`,
    }));
    // нужно также объединить полученные mac адреса вместе с текущим, если он есть
    if (
      this.pmodule.device &&
      this.macs.filter(v => v.device === this.pmodule.device).length <= 0
    ) {
      this.macs = [...macs, {device: this.pmodule.device, description: this.pmodule.device}];
    } else {
      this.macs = [...macs];
    }
  }

  beforeDestroy() {
    this.closeWS();
  }

  // Закрыть соединения веб сокетов
  closeWS() {
    if (this.socket) {
      this.socket.close();
      this.socket = null;
    }
  }

  get cancelChangesDialog() {
    return this.$refs.cancelChangesDialog as any;
  }

  back() {
    // если были внесены изменения на форме
    if (this.changed) {
      this.cancelChangesDialog.open('/sensors');
    } else router.push('/sensors');
  }
}
